import { useTranslation } from 'react-i18next';
import StatusBadge from './StatusBadge';
import { formatJst } from './time';

const COLUMNS = ['name', 'status', 'features', 'teams', 'starts', 'ends'];

const CampaignList = ({ campaigns, onOpen, onEnd }) => {
  const { t } = useTranslation();
  const teamsLabel = (c) =>
    c.scope?.all
      ? t('subscription.admin.campaigns.allTeams')
      : (c.scope?.teamIds || []).map((team) => team.name).join(', ');

  return (
    <table className="w-full text-left text-[13px]">
      <thead>
        <tr className="text-[11px] font-bold text-gray-600 border-b border-[#e5e7eb]">
          {COLUMNS.map((key) => (
            <th key={key} className="px-6 py-2">{t(`subscription.admin.campaigns.column.${key}`)}</th>
          ))}
          {onEnd && <th className="px-6 py-2" />}
        </tr>
      </thead>
      <tbody>
        {campaigns.map((c) => (
          <tr
            key={c._id}
            aria-label={c.name}
            onClick={() => onOpen(c)}
            className="cursor-pointer border-b border-[#F0F2F4] hover:bg-[#F9FAFB]"
          >
            <td className="px-6 py-3 font-semibold text-[#20252D]">{c.name}</td>
            <td className="px-6 py-3"><StatusBadge status={c.status} /></td>
            <td className="px-6 py-3">
              {c.features.map((f) => t(`subscription.admin.campaigns.feature.${f}`)).join(', ')}
            </td>
            <td className="px-6 py-3">{teamsLabel(c)}</td>
            <td className="px-6 py-3">{formatJst(c.startsAt)}</td>
            <td className="px-6 py-3">{formatJst(c.endsAt)}</td>
            {onEnd && (
              <td className="px-6 py-3 text-right">
                {c.status === 'active' && (
                  <button
                    className="text-[12px] font-semibold text-[#FA3F58] hover:underline"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEnd(c);
                    }}
                  >
                    {t('subscription.admin.campaigns.endNow')}
                  </button>
                )}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CampaignList;
